'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
    var _ref = arguments[1];
    var type = _ref.type,
        payload = _ref.payload;

    switch (type) {
        case "@@loadAppReal":
            return loadApp(state, payload);
        case "@@reduce":
            return reduce(state, payload);
        case "@@clearAppState":
            return clearAppState(state, payload);
        default:
            return state;
    }
};

var _immutable = require('immutable');

var _wrapMapStateToProps = require('./wrapMapStateToProps');

var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);

var _wrapMapDispatchToProps = require('./wrapMapDispatchToProps');

var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);

var _createReduxConnector = require('./createReduxConnector');

var _createReduxConnector2 = _interopRequireDefault(_createReduxConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadApp(state, _ref2) {
    var fullName = _ref2.fullName,
        prevFullName = _ref2.prevFullName,
        appInfo = _ref2.appInfo,
        _ref2$component = _ref2.component,
        component = _ref2$component === undefined ? {} : _ref2$component,
        _ref2$action = _ref2.action,
        action = _ref2$action === undefined ? {} : _ref2$action,
        _ref2$reducer = _ref2.reducer,
        reducer = _ref2$reducer === undefined ? {} : _ref2$reducer;

    if (!state.has(fullName)) {
        state = state.set(fullName, (0, _immutable.Map)());

        var actionInstance = typeof action == 'function' ? action({ appInfo: appInfo, fullName: fullName }) : action,
            reducerInstance = typeof reducer == 'function' ? reducer({ appInfo: appInfo, fullName: fullName }) : reducer,
            container = (0, _createReduxConnector2.default)(component, (0, _wrapMapStateToProps2.default)(fullName), (0, _wrapMapDispatchToProps2.default)(fullName, actionInstance, reducerInstance), null, { withRef: true, pure: true });

        state = state.setIn([fullName, '@@require'], (0, _immutable.Map)({
            fullName: fullName,
            appInfo: appInfo,
            component: component,
            action: actionInstance,
            reducer: reducerInstance,
            container: container
        }));
    }

    if (prevFullName && prevFullName != fullName) {
        state = clearAppState(state, { fullName: prevFullName });
    }

    return state;
}

function clearAppState(state, _ref3) {
    var fullName = _ref3.fullName;


    if (!state.has(fullName)) return state;

    var ks = [];
    state.get(fullName).mapKeys(function (k) {
        if (k != '@@require') ks.push(k);
        return k;
    });

    ks.forEach(function (k) {
        if (k) state = state.update(fullName, function (x) {
            return x.remove(k);
        });
    });

    return state;
}

function reduce(state, _ref4) {
    var reducer = _ref4.reducer,
        type = _ref4.type,
        payload = _ref4.payload,
        fullName = _ref4.fullName,
        injectFunsForReducer = _ref4.injectFunsForReducer;


    var startDate = new Date();
    var oldState = state.get(fullName);
    var newState = reducer[type].apply(this, [oldState].concat(payload));

    if (typeof newState === "function") {
        newState = newState(injectFunsForReducer);
    }

    if (window.__mk_record_action__ === true) {
        window.__mk_actions__ = window.__mk_actions__ || [];
        var endDate = new Date();
        window.__mk_actions__.unshift({
            appFullName: fullName,
            reduceMethod: type,
            payload: payload,
            oldState: oldState,
            newState: newState,
            startTime: startDate.getHours() + ':' + startDate.getMinutes() + ':' + startDate.getSeconds() + '.' + startDate.getMilliseconds(),
            endTime: endDate.getHours() + ':' + endDate.getMinutes() + ':' + endDate.getSeconds() + '.' + endDate.getMilliseconds(),
            elapsedTime: Math.abs(startDate.getTime() - endDate.getTime()) //(1000*60*60*24)
        });
    } else {
        if (window.__mk_actions__) window.__mk_actions__ = undefined;
    }

    return state.set(fullName, newState);
}
module.exports = exports['default'];